import { render, staticRenderFns } from "./InstrumentPanel.vue?vue&type=template&id=6c5ca66a&"
import script from "./InstrumentPanel.vue?vue&type=script&lang=js&"
export * from "./InstrumentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InstrumentPanel.vue"
export default component.exports